import Path from "../../services/paths";
import NotificationActions from "../actions/notificationActions";
import utils from "../common/utils";
import axios from "axios";

class NotificationMiddleware {
  static getNotifications(
    page,
    viewed
  ) {
    let url = `${Path.GET_NOTIFICATIONS}?`;
    if (page) {
      url += `page=${page}&`;
    }
    
    if (viewed===false) {
      url += `viewed=${viewed}&`;
    } else {
      url += `viewed=true&`;
    }

    url = url.slice(0, -1);
    // console.log("URL", url);

    return dispatch => {
      dispatch(NotificationActions.notificationRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                // console.log("SUCCESS", res);
                dispatch(NotificationActions.notificationSuccessul(res));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              dispatch(NotificationActions.notificationFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(NotificationActions.notificationFailed(error));
        });
    };
  }

  static postViewedNotification(NotificationView1){
      let NotificationView={
          guid:NotificationView1
        }
    //   NotificationView.append("guid",NotificationView1)
    let url = `${Path.POST_VIEWED_NOTIFICATIONS}`;
    return dispatch => {
        // dispatch(NotificationActions.notificationRequest());
  
        utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            data:NotificationView,
            // responseType: 'blob',
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            },
          })
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                // const url = window.URL.createObjectURL(new Blob([res.data]));
                // console.log("DOWNLOAD SUCCESS", res);
                // const link = document.createElement('a');
                // link.href = url;
                // link.setAttribute('download', 'PrimaryDashboard.xlsx'); //or any other extension
                // document.body.appendChild(link);
                // link.click();
                // dispatch(NotificationActions.notificationSuccessul(res));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
            //   dispatch(NotificationActions.notificationFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
        //   dispatch(NotificationActions.notificationFailed(error));
        });
      };
  }
}

export default NotificationMiddleware;
